/** @format */
import {SUBSTRATE_ULTRA_CLEAR_PLASTIC} from './constants';

/**
 * Get the substrate thicknesses from the window variable or fetch from the API if an order ID is provided
 * @param {number|null} orderId - Optional order ID to look up supplies
 * @returns {Promise<Array>|Array} The substrate thicknesses (Promise if orderId is provided)
 */
export const getSubstrateThicknesses = (orderId = null) => {
    // If no order ID is provided, use the window variable
    if (!orderId) {
        // Check if the databaseConstants is available in the window
        if (
            typeof window !== 'undefined' &&
            window.databaseConstants &&
            window.databaseConstants.substrateThicknesses
        ) {
            // Process the thicknesses to add the withHighOpacityWhite property
            return window.databaseConstants.substrateThicknesses.map(thickness => {
                if (thickness.id === SUBSTRATE_ULTRA_CLEAR_PLASTIC) {
                    return {
                        ...thickness,
                        withHighOpacityWhite: thickness.default + 0.0005
                    };
                }
                return thickness;
            });
        }

        // If window variable is not available, log a warning
        console.warn('Substrate thicknesses not found in window.databaseConstants');
        return [];
    }

    // If an order ID is provided, fetch the thicknesses from the API
    return new Promise(resolve => {
        import('superagent').then(SuperAgentModule => {
            const SuperAgent = SuperAgentModule.default;

            SuperAgent.get('/api/substrates/thicknesses')
                .query({order_id: orderId})
                .set('accept', 'application/json')
                .then(response => {
                    const thicknesses = response.body.thicknesses.map(thickness => {
                        // The API now returns the combined thickness (substrate + laminate) for all substrates
                        // We still need to add the withHighOpacityWhite property for ULTRA_CLEAR_PLASTIC
                        if (thickness.id === SUBSTRATE_ULTRA_CLEAR_PLASTIC) {
                            return {
                                ...thickness,
                                withHighOpacityWhite: thickness.default + 0.0005
                            };
                        }
                        return thickness;
                    });

                    resolve(thicknesses);
                })
                .catch(error => {
                    console.error('Error fetching substrate thicknesses:', error);
                    // Fall back to window variable
                    if (
                        typeof window !== 'undefined' &&
                        window.databaseConstants &&
                        window.databaseConstants.substrateThicknesses
                    ) {
                        resolve(
                            window.databaseConstants.substrateThicknesses.map(thickness => {
                                if (thickness.id === SUBSTRATE_ULTRA_CLEAR_PLASTIC) {
                                    return {
                                        ...thickness,
                                        withHighOpacityWhite: thickness.default + 0.0005
                                    };
                                }
                                return thickness;
                            })
                        );
                    } else {
                        resolve([]);
                    }
                });
        });
    });
};
